import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Spin } from "antd";
import ContractHeader from "../Contract/components/Navigation/ContractHeader";
import { getThankYouContent } from "../Contract/services/contractApi";
import "./ThankYou.css";

const ThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const exhibitorName = location.state?.exhibitorName || null;

  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getThankYouContent()
      .then((data) => setContent(data))
      .catch(() => {
        // Silently fall back to defaults
      })
      .finally(() => setLoading(false));
  }, []);

  const renderBlock = (block, index) => {
    switch (block.block_type) {
      case "heading":
        return (
          <div key={block.id ?? index} className="ty-block ty-block--heading">
            <h3 className="ty-heading">{block.content}</h3>
          </div>
        );
      case "paragraph":
        return (
          <div key={block.id ?? index} className="ty-block ty-block--paragraph">
            <p className="ty-paragraph">{block.content}</p>
          </div>
        );
      case "bullets":
        return (
          <div key={block.id ?? index} className="ty-block ty-block--bullets">
            <ul className="ty-bullets">
              {block.content
                .split("\n")
                .map((line) => line.trim())
                .filter(Boolean)
                .map((item, i) => (
                  <li key={i} className="ty-bullet-item">
                    <span className="ty-bullet-dot" />
                    <span>{item}</span>
                  </li>
                ))}
            </ul>
          </div>
        );
      default:
        return null;
    }
  };

  const activeBlocks = content?.blocks?.filter((b) => b.is_active !== false) ?? [];

  return (
    <div className="ty-page">
      <ContractHeader />

      <main className="ty-main">
        {/* Hero */}
        <div className="ty-hero">
          <div className="ty-checkmark-wrap">
            <div className="ty-checkmark-circle">
              <svg
                className="ty-checkmark-svg"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  className="ty-checkmark-circle-ring"
                  cx="26"
                  cy="26"
                  r="25"
                  stroke="white"
                  strokeWidth="2"
                  fill="none"
                />
                <polyline
                  className="ty-checkmark-tick"
                  points="14,27 22,35 38,19"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
              </svg>
            </div>
          </div>

          <h1 className="ty-hero-title">
            {content?.title || "Contract Submitted Successfully!"}
          </h1>

          {exhibitorName && (
            <p className="ty-hero-name">
              Thank you, <strong>{exhibitorName}</strong>
            </p>
          )}

          {content?.subtitle && (
            <p className="ty-hero-subtitle">{content.subtitle}</p>
          )}

          {!content?.subtitle && !loading && (
            <p className="ty-hero-subtitle">
              Your contract has been received. Our team will be in touch shortly.
            </p>
          )}
        </div>

        {/* Dynamic Content Blocks */}
        {loading ? (
          <div className="ty-loading">
            <Spin size="large" />
            <p>Loading...</p>
          </div>
        ) : activeBlocks.length > 0 ? (
          <div className="ty-blocks">
            {activeBlocks.map((block, i) => renderBlock(block, i))}
          </div>
        ) : null}

        {/* Actions */}
        <div className="ty-actions">
          <button
            className="btn btn-primary ty-btn"
            onClick={() => navigate("/welcome")}
          >
            Return to Dashboard
          </button>
        </div>

        <p className="ty-footer-note">
          Please refer to the vendor portal for any updates. Email updates will
          be sent — whitelist all <strong>@arett.com</strong> domains.
        </p>
      </main>
    </div>
  );
};

export default ThankYou;
